import { XIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

type ChipProps = {
  label: string;
  icon: React.ReactNode;
  onRemove?: () => void;
};

export function ContextChip({ label, icon, onRemove }: ChipProps) {
  return (
    <div className="flex items-center gap-1 rounded-sm bg-muted text-muted-foreground select-none text-xs shrink-0 h-6 px-1">
      {icon}
      <div className="px-1 inline-flex items-center gap-2">
        <Tooltip delayDuration={1500}>
          <TooltipTrigger asChild>
            <span className="truncate max-w-36">{label}</span>
          </TooltipTrigger>
          <TooltipContent>{label}</TooltipContent>
        </Tooltip>
        {onRemove && (
          <Button
            variant="ghost"
            size="icon"
            className="size-3"
            onClick={onRemove}
          >
            <XIcon className="size-3" />
          </Button>
        )}
      </div>
    </div>
  );
}
